import React from 'react';
import Ticket from '../components/Ticket';
import Page from '../components/Page';
import {
    Col,
    Row,
} from 'reactstrap';
import BaseService from '../services/BaseService';

class TicketPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: []
        }
    }
    getData() {
        let url = BaseService.ENDPOINT + 's9ejf0wjkr0kkf0';
        return fetch(url, {
            method: 'GET',
            headers: new Headers({
                'Accept': 'application/json'
            })
        })
            .then((response) => response.json())
            .then((json) => {
                if (json.return.code === 1) {
                    this.setState({ data: json.data })
                }
            });
    }
    componentDidMount() {
        this.getData();
    }
    render() {
        let TicketValue = () => {
            if (typeof this.state.data.id !== 'undefined') {
                return (
                    <Ticket
                        value={"R$ " + parseFloat(this.state.data.credit).toFixed(2)}
                        receipt={this.state.data.id}
                        date={this.state.data.date_parking}
                        plate={this.state.data.plate}
                        time={this.state.data.spot_type}
                    />
                );
            }
            else {
                return (
                    <h4>Ticket não existe</h4>
                );
            }
        }
        return (
            <Page
                title="Ticket"
                className="TicketPage">
                <Row>
                    <Col></Col>
                    <Col>
                        {TicketValue()}
                    </Col>
                    <Col></Col>
                </Row>

            </Page>
        );
    }
}

export default TicketPage;


// WEBPACK FOOTER //
// ./src/pages/TicketPage.js